import { createSlice } from "@reduxjs/toolkit";

const LoadingInitalState = {
  isLoading: false,
};

const LoadingSlice = createSlice({
  name: "Loading",
  initialState: LoadingInitalState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});
export const { setLoading } = LoadingSlice.actions;
export const loadingReducer = LoadingSlice.reducer;

const userInitialState = {
  user: null,
};

const userSlice = createSlice({
  name: "user",
  initialState: userInitialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;
export const userReducer = userSlice.reducer;

const WalletInitalState = {
  walletAddress: null,
};

const walletSlice = createSlice({
  name: "wallet",
  initialState: WalletInitalState,
  reducers: {
    setWalletAddress: (state, action) => {
      state.walletAddress = action.payload;
    },
  },
});

export const { setWalletAddress } = walletSlice.actions;
export const walletReducer = walletSlice.reducer;

// promotional state
const PromotionInitalState = {
  isCompleted: false,
};

const PromotionSlice = createSlice({
  name: "Promotion",
  initialState: PromotionInitalState,
  reducers: {
    setCompleted: (state, action) => {
      state.isCompleted = action.payload;
    },
  },
});
export const { setCompleted } = PromotionSlice.actions;
export const promotionReducer = PromotionSlice.reducer;

// user instraction state
const instractionState = {
  show: false,
};

const instractionSlice = createSlice({
  name: "Instraction",
  initialState: instractionState,
  reducers: {
    setShow: (state, action) => {
      state.show = action.payload;
    },
  },
});
export const { setShow } = instractionSlice.actions;
export const instractionReducer = instractionSlice.reducer;
